// Map{id->state} with registered spinners
const registeredInstances = {};

// Queue of requests to activate (in case it triggers before registration)
const pendingQueue = [];

/**
 * @param {String} id spinner identification value
 * @description Activates spinner with passed id. If spinner is not yet
 * registered stores it in pending queue. So it will be activated as
 * soon as it will be registered.
 */
export const activate = (id) => {
  const instance = registeredInstances[id];
  if (instance) {
    instance.active = true;
    instance.toggle(true);
  } else {
    pendingQueue.push(id);
  }
};

/**
 * @param {String} id spinner identification value
 * @param {Function} toggle function that will change spinner's state
 * @description Registers spinner in service. If spinner is in pending queue
 * activates it and removes from the queue.
 */
export const register = (id, toggle) => {
  registeredInstances[id] = {
    active: false,
    toggle,
  };

  const index = pendingQueue.indexOf(id);
  if (index >= 0) {
    activate(id);
    pendingQueue.splice(index, 1);
  }
};

/**
 * @param {String} id spinner identification valletue
 * @description Unregisters spinner with passed id.
 */
export const unregister = (id) => {
  delete registeredInstances[id];
};

/**
 * @param {String} id spinner identification value
 * @description Terminates spinner with passed id. If spinner is not yet
 * registered removes it from pending queue.
 */
export const terminate = (id) => {
  const instance = registeredInstances[id];
  if (instance) {
    instance.active = false;
    instance.toggle(false);
  } else {
    const index = pendingQueue.indexOf(id);
    if (index >= 0) {
      pendingQueue.splice(index, 1);
    }
  }
};

/**
 * @param {String} id spinner identification value
 * @description Check whether spinner with provided id is active or not.
 */
export const isActive = (id) => {
  const instance = registeredInstances[id];
  return (instance && instance.active) || pendingQueue.indexOf(id) >= 0;
};

/**
 * @description Terminates all spinners
 */
export const terminateAll = () => {
  Object.keys(registeredInstances).forEach((id) => terminate(id));
};
